"use client";
import { jsxs as h, jsx as l } from "react/jsx-runtime";
const f = ({
  title: i,
  titleId: a,
  desc: d,
  descId: e,
  ...n
}) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-vc",
    viewBox: "0 0 640 480",
    "aria-labelledby": a,
    "aria-describedby": e,
    ...n,
    children: [
      d ? /* @__PURE__ */ l("desc", { id: e, children: d }) : null,
      i ? /* @__PURE__ */ l("title", { id: a, children: i }) : null,
      /* @__PURE__ */ h("g", { fillRule: "evenodd", children: [
        /* @__PURE__ */ l("path", { fill: "#f4f100", d: "M0 0h640v480H0z" }),
        /* @__PURE__ */ l("path", { fill: "#199a00", d: "M490 0h150v480H490z" }),
        /* @__PURE__ */ l("path", { fill: "#0058aa", d: "M0 0h150v480H0z" }),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "#199a00",
            d: "m259.3 130-46.4 71.3 44.7 74.4 43.8-73.7zm121.2 0-46.3 71.3 44.7 74.4 43.8-73.7zm-61.2 97.3-46.4 71.4 44.8 74.4 43.8-73.7-42.2-72z"
          }
        )
      ] })
    ]
  }
);
export {
  f as default
};
